import { render, staticRenderFns } from "./ManageAppAccess.vue?vue&type=template&id=cd7bbca8"
import script from "./ManageAppAccess.vue?vue&type=script&lang=js"
export * from "./ManageAppAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports